import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Email } from './email';
import { Subject } from './subject';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  apiUrl = `${environment.eCompApiUrl}/api/emails`;
  subjectsResponse;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  constructor(private http: HttpClient) {}

  sendEmail(email: Email) {
    return this.http.post(`${this.apiUrl}/send`, {
      name: email.name,
      from: email.from,
      subject: email.subject,
      message: email.message,
      captcha: email.captcha
    });
  }

  getSubjects(): Observable<Subject[]> {
    return this.http.get<Subject[]>(`${this.apiUrl}/subjects`);
  }

  getRecaptchaKey(): Observable<string> {
    return this.http.get(`${this.apiUrl}/recaptchakey`, {responseType: 'text'});
  }
}
